"use client";
import {
  chip_default
} from "./chunk-4WFLSIHH.mjs";
import {
  useChip
} from "./chunk-TWKIP7BA.mjs";
export {
  chip_default as Chip,
  useChip
};
